// extracted by mini-css-extract-plugin
export default {"background":"UploadPopup_background__BcFjR","container":"UploadPopup_container__L08KC"};